export function createCondicionPago() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    DiasCredito: null,
    EsActivo: true
  };
}
